import { memo } from 'react';

import type { FC, SVGAttributes } from 'react';

export interface InfoBlockIconProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
}

const InfoBlockIcon: FC<InfoBlockIconProps> = (props) => {
  return (
    <svg
      {...props}
      width='108'
      height='77'
      viewBox='0 0 108 77'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='22.4004' y='18.1963' width='79.6' height='53.6' fill='#CCCCE6' stroke='#404040' />
      <g clipPath='url(#clip0_60_4776)'>
        <path
          d='M60.034 42.8301V46.6208M64.312 42.8301V46.6208M62.2001 61.0793V24.96M73.7886 61.0793L74.655 65.0324H72.7344L71.3265 61.0793M50.6115 61.0793L49.7451 65.0324H51.6657L53.0737 61.0793M74.655 24.96H49.7451V61.0793H74.655V24.96Z'
          stroke='#404040'
          strokeMiterlimit='10'
        />
      </g>
      <rect x='18.5' y='71.4961' width='87.4' height='4.2' fill='#CCCCE6' stroke='#404040' />
      <circle cx='77.022' cy='57.2319' r='9.05859' fill='#CCCCE6' stroke='#404040' />
      <path
        d='M77.7339 60.6767H80.6934'
        stroke='#404040'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M77.3409 53.8843C77.6574 53.5061 78.2264 53.4507 78.6125 53.7606C78.6339 53.7775 79.3198 54.3101 79.3198 54.3101C79.744 54.5665 79.8758 55.1114 79.6136 55.5273C79.5996 55.5496 75.7217 60.3986 75.7217 60.3986C75.5927 60.5595 75.3969 60.6545 75.1875 60.6568L73.7025 60.6754L73.3679 59.2597C73.321 59.0606 73.3679 58.8515 73.4969 58.6906L77.3409 53.8843Z'
        stroke='#404040'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M76.8398 54.7832L78.8921 56.3549'
        stroke='#404040'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='18' cy='17.6963' r='16.8613' fill='white' stroke='#404040' />
      <path
        d='M19.0472 11.3163H19.7132V23.1963H17.8052V13.5663L15.3932 14.3403L14.9252 12.6663L19.0472 11.3163Z'
        fill='#404040'
      />
      <defs>
        <clipPath id='clip0_60_4776'>
          <rect
            width='25.993'
            height='41.1555'
            fill='white'
            transform='translate(49.2036 24.4185)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(InfoBlockIcon);
